import { Outlet } from "react-router-dom";
import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";

/**
 * Shared chrome for public content pages (tours, nosotros, ayuda, blog, etc.).
 * These pages render only their own content — the fixed Header (which carries the
 * logo link back to home) and the Footer are provided here so every public page
 * has consistent navigation. The homepage renders its own Header/Footer and is
 * intentionally NOT wrapped by this layout.
 */
export default function PublicChrome() {
  return (
    <>
      <Header />
      <Outlet />
      <Footer />
    </>
  );
}
